// extracted by mini-css-extract-plugin
module.exports = {"icon":"FilterDropdownMenu_icon__27aGh"};